<template>
  <q-slide-transition>
    <info-card
      v-if="banner"
      :type="bannerType"
      :message="bannerMsg"
      :rounded="false"
    />
  </q-slide-transition>
</template>

<script setup lang="ts">
import { computed, watch } from 'vue'
import { useI18n } from 'vue-i18n'

import { useEventsStore } from 'stores/common/events'

import InfoCard from 'components/common/ui/card/InfoCard.vue'

import type { AlertBannerType } from 'types/common/account/user'

const banner = defineModel<AlertBannerType | null>('banner', { required: true })

const { locale } = useI18n()

const bannerMsg = computed(() => {
  if (!banner.value) return ''
  return (
    banner.value.messages.find((msg) => msg.language === locale.value)
      ?.message || ''
  )
})

const bannerType = computed(() => {
  if (!banner.value) return 'muted'
  return bannerTypes[banner.value.type]
})

const bannerTypes: Record<
  AlertBannerType['type'],
  InstanceType<typeof InfoCard>['$props']['type']
> = {
  info: 'info',
  warning: 'warning',
  alert: 'negative',
  success: 'positive',
}

const eventsStore = useEventsStore()

watch(
  () => eventsStore.eventData,
  (val) => {
    if (val?.type === 'banner_hide') {
      banner.value = null
    }
    if (val?.type === 'banner_show') {
      banner.value = val.context
    }
  }
)
</script>
